import { getTenantId } from './cepspy';

const tenantThemes = {
  '519766': {
    '--theme-global-text-color': '#ffffff',
    '--theme-global-bg-color': '#4d4d4d',
    '--theme-primary': '#ff9759',
    '--theme-content-bg': '#424242',
    '--theme-nav-bg': '#424242',
    '--theme-sidebar-first-bg': '#ff9759'
  }
};

export function applyTenantTheme() {
  try {
    const tenantId = String(getTenantId());
    const theme = tenantThemes[tenantId];
    if (!theme) return;
    Object.entries(theme).forEach(([key, val]) => {
      document.documentElement.style.setProperty(key, val);
    });
  } catch (e) {
    // cep-spy 可能在浏览器开发模式下不可用
  }
}



// WEBPACK FOOTER //
// ./src/utils/tenantThemes.js